import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { ArtifactEditorForm } from "@/features/lead-gen/components/ArtifactEditorForm";
import { LeadGenDetailShell } from "@/features/lead-gen/components/LeadGenDetailShell";
import { useLeadGen } from "@/features/lead-gen/LeadGenContext";
import { useNav } from "@/utils/nav";

export const Route = createFileRoute("/_app/sales/leads/artifacts/new")({
    component: NewLeadArtifactPage,
});

function NewLeadArtifactPage() {
    const { setArtifacts } = useLeadGen();
    const navigate = useNavigate();

    useNav([
        { label: "Sales", route: { to: "/sales/leads" } },
        { label: "Leads", route: { to: "/sales/leads" } },
        { label: "Artefacts", route: { to: "/sales/leads/artifacts" } },
        { label: "New", route: { to: "/sales/leads/artifacts/new" } },
    ]);

    return (
        <LeadGenDetailShell
            backTo="/sales/leads/artifacts"
            backLabel="All artefacts"
            summary={
                <p className="text-slate-500 text-sm">
                    Markdown notes any template can reuse, such as company context.
                </p>
            }
        >
            <ArtifactEditorForm
                artifact={null}
                onCancel={() => void navigate({ to: "/sales/leads/artifacts" })}
                onSave={(next) => {
                    setArtifacts((current) => [...current, next]);
                    void navigate({
                        to: "/sales/leads/artifacts/$artifactId",
                        params: { artifactId: next.id },
                    });
                }}
            />
        </LeadGenDetailShell>
    );
}
